import { inject, Injectable } from '@angular/core';
import { RequestService } from './request.service';

@Injectable({
  providedIn: 'root'
})
export class MedicalHistoryService {
  private readonly requestService = inject(RequestService);

  sendPatientMedicalRecords(id: string): Promise<{ result: string }> {
    return this.requestService.post(`/email/patient/${id}/sendMedicalRecords`, {});
  }

  getMedicalHistory(records?: string[], aiDetectedPathologicalHistory?: string): string | undefined {
    records = records || [];
    const aiRecords = aiDetectedPathologicalHistory
      ? aiDetectedPathologicalHistory
          .split(',')
          .map((r) => r.trim())
          .filter((r) => r)
      : [];
    return [...new Set([...records, ...aiRecords])].join(', ');
  }
}
